import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import CardCampaignShortcut, { CardCampaignShortcutsProps } from '../card-campaign-shortcut/card-campaign-shortcut.component'
import './campaigns-shortcuts.component.scoped.scss'

export default () => {
  const { t } = useTranslation('campaignsShortcuts')

  const cardsShortcuts: CardCampaignShortcutsProps[] = useMemo(
    () => [
      {
        icon: 'fa-bullhorn',
        label: t('campaigns'),
        path: '/campaigns',
        index: 1,
      },
      {
        icon: 'fa-calendar-circle-user',
        label: t('invited'),
        path: '/campaigns/invited',
        index: 2,
      },
      {
        icon: 'fa-bars-progress',
        label: t('applicationSent'),
        path: '/campaigns/sent',
        index: 3,
      },
      {
        icon: 'fa-camera',
        label: t('participating'),
        path: '/campaigns/participating',
        index: 4,
      },
      {
        icon: 'fa-flag-checkered',
        label: t('finished'),
        path: '/campaigns/finished',
        index: 5,
      },
    ],
    [t]
  )

  useEffect(() => {
    const cards = document.querySelectorAll('.card-campaign-shortcut')
    const numCards = cards?.length

    for (let i = 1; i <= numCards; i++) {
      cards?.[i - 1]?.classList?.add(`card--background-position-${i}`)
    }
  }, [])

  return (
    <div className="campaigns-shortcuts">
      <h3 className="title m-0">{t('campaigns')}</h3>
      <div className="list-cards my-3 display-flex justify-content-start">
        {cardsShortcuts?.map((cardShortcut, index) => (
          <CardCampaignShortcut key={index} {...cardShortcut} />
        ))}
      </div>
    </div>
  )
}
